import { Box } from "@mui/material";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { memo } from "react";
import { InternalUseWithDisclosures } from "../assetAllocation/editPortfolioGroup/InternalUse";
import { CarDownloadButton } from "@app/components/Buttons";
import { CarPageContentCode, usePageContent } from "@app/hooks/usePageContent";
import { CarPageContent } from "@app/components/PageContent";
import { ChartSimulatedForwardProbabilitiesAC } from "./ChartSimulatedForwardProbabilitiesAC";
import { useSimulatedForwardProbabilitiesAC } from "./useSimulatedForwardProbabilitiesAC";
import { useSimulationGroups } from "@app/pages/assetAllocation/useSimulationGroups";
import { useSimulationSimulationJobLatestSimulationRetrieveQuery } from "@app/api/carApi.generated";

export const AssetClassAnalysisSimulatedForwardProbabilities = memo(() => {
  const simulationGroups = useSimulationGroups();
  const latestSimulation =
    useSimulationSimulationJobLatestSimulationRetrieveQuery();
  const simulationJobId1 = latestSimulation.data?.id;
  const simulationJobId2 = latestSimulation.data
    ? latestSimulation.data?.is_static
      ? simulationGroups.lastPriceDrivenSimulationJobId
      : simulationGroups.lastStaticSimulationJobId
    : undefined;

  const data = useSimulatedForwardProbabilitiesAC({
    simulationJobId1,
    simulationJobId2,
  });

  const pageContent = usePageContent();

  return (
    <TablePlaceHolder
      isLoading={
        simulationGroups.isLoading ||
        latestSimulation.isLoading ||
        data.isLoading ||
        pageContent.isLoading
      }
      rows={8}
    >
      <Box sx={{ display: "flex", alignItems: "flex-end", mr: -1.5 }}>
        <CarDownloadButton onClick={data.handleShowPdf} sx={{ ml: "auto" }}>
          Download Current
        </CarDownloadButton>
        <CarDownloadButton onClick={data.handleShowPdfAll}>
          Download All
        </CarDownloadButton>
      </Box>
      <CarPageContent
        sx={{ mt: 1 }}
        isWhiteContext
        content={pageContent.getContent(
          CarPageContentCode.ASSET_CLASS_MONTHLY_REPORT_SIMULATED_FORWARD_PROBABILITY_DIRECTIONS,
        )}
      />
      <Box
        sx={{
          mt: 3,
          alignSelf: "stretch",
          display: "flex",
          alignItems: "center",
        }}
      >
        <InternalUseWithDisclosures sx={{ ml: "auto" }} />
      </Box>
      <ChartSimulatedForwardProbabilitiesAC data={data} />
    </TablePlaceHolder>
  );
});
